<!--

When using more than one SearchForm component you have to make sure that only one can set the location by clicking on the map.

Example:

import SearchForm from "../SearchForm.svelte";
let searchForms:Array<any> = [
    {id: 1, elem: null},
    {id: 2, elem: null},
    {id: 3, elem: null}
];
let searchFormLocation: any = null;
let onSearchFormSet = function(form: any, evt: any) {
    console.log('onSearchFromSet', form, evt);
    searchFormLocation = new Targeo.MapObject.Oval(evt.detail.coords, 5, null, {interactive: false, zmax: 26, visible: true, strokeWidth: 2, strokeColor: '#000000', fillColor: '#ffffff'});
    Targeo.Base.Map.UOAdd(searchFormLocation);
}
let onSearchFormUnset = function(form: any) {
    if (searchFormLocation) {
        Targeo.Base.Map.UORemove(searchFormLocation.id);
        searchFormLocation = null;
    }
}
let onSearchFormPointOnMap = function(form: any) {
    for (let i = 0; i < searchForms.length; i++) {
        if (searchForms[i].elem != form.elem) {
            searchForms[i].elem.closePointOnMap(false);
        }
    }
}

{#each searchForms as searchForm}
    <SearchForm bind:this={searchForm.elem} pointOnMap={true} coords={null} validSearchResult={null} label={null} on:set={(evt) => onSearchFormSet(searchForm, evt)} on:unset={(evt) => onSearchFormUnset(searchForm, evt)} on:pointonmap={(evt) => onSearchFormPointOnMap(searchForm, evt)} />
{/each}

-->

<script lang="ts">
    import { onMount, createEventDispatcher } from 'svelte';
    import { onMapReady } from '../utilities/onMapReady';

    interface FTSForm {
        initialize: (container: HTMLElement) => void;
        listen: (eventType: string, handler: (ev: any) => any) => any;
        performSearch: () => any;
    }
    interface SuggestItem {
        type: string;
        objecttype: string;
        coords: Object;
    }

    export let pointOnMap: boolean;
    export let coords: Object | null;
    export let validSearchResult: ((item: SuggestItem) => boolean) | null;
    export let label: string | null;
    export let placeholder: string = 'address_or_coordinates';

    let dispatch = createEventDispatcher();

    // @ts-ignore
    let TargeoObj: any = Targeo;
    let container: HTMLElement;
    let inputContainer: HTMLElement;
    let input: HTMLInputElement;
    let suggestElement: HTMLElement;
    let stateButton: HTMLElement;
    let suggestTimeout: any;
    let lastQuery: string | null = null;
    let ftsform: FTSForm;
    let pointOnMapBar: HTMLElement;
    let pointOnMapListener: any;

    let addSearchFormListeners = function () {
        ftsform.listen('onSearchResult', function (ev: any) {
            let item: any = false;
            if (ev.results.length) {
                for (let i = 0, ii = ev.results.length; i < ii; i++) {
                    item = ev.results[i];
                    if ((item.xy || item.coords) && (typeof(validSearchResult) == 'function' && validSearchResult(item))) {
                        break;
                    } else {
                        item = false;
                    }
                }
            }
            if (stateButton) {
                stateButton.classList.remove('changing');
            }
            if (item !== false) {
                lastQuery = input.value;
                setCoordinate(
                    item.type == 'coords'
                        ? { x: item.coords.x, y: item.coords.y }
                        : item.xy,
                    item,
                    false
                );
            } else if (!input.value || input.value != lastQuery) {
                unsetCoordinate();
                if (stateButton) {
                    stateButton.classList.remove('set', 'changing');
                }
                if (input.value) {
                    input.classList.add('search-point-form-error');
                    input.setAttribute('title', 'Nie znaleziono adresu');
                }
            }
        });
        ftsform.listen('onSuggestShow', function () {
            if (suggestTimeout) {
                clearTimeout(suggestTimeout);
                suggestTimeout = null;
            }
            if (suggestElement) {
                if (suggestElement.childNodes.length > 0) {
                    suggestElement.style.display = 'block';
                } else {
                    suggestElement.style.display = 'none';
                }
            }
        });
        ftsform.listen('onSuggestHide', function () {
            if (suggestElement) {
                suggestElement.style.display = 'none';
            }
            if (suggestTimeout) {
                clearTimeout(suggestTimeout);
            }
            if (input != document.activeElement) {
                suggestTimeout = setTimeout(function () {
                    if (input.value && input.value != lastQuery) {
                        input.classList.add('search-point-form-error');
                        input.setAttribute('title', 'Nie znaleziono adresu');
                        unsetCoordinate();
                    }
                }, 250);
            }
        });
        ftsform.listen('onCountryTableShow', function () {
            if (suggestTimeout) {
                clearTimeout(suggestTimeout);
                suggestTimeout = null;
            }
            if (suggestElement) {
                suggestElement.style.display = 'block';
            }
        });
        ftsform.listen('onCountryTableHide', function () {
            if (suggestElement) {
                suggestElement.style.display = 'none';
            }
            if (suggestTimeout) {
                clearTimeout(suggestTimeout);
            }
        });
        ftsform.listen('onCountrySelect', function () {
            if (input.value == lastQuery) {
                lastQuery = '';
                input.value = '';
                input.setAttribute('title', '');
                unsetCoordinate();
            }
        });
        input.addEventListener('keyup', function () {
            if (
                input.value != lastQuery &&
                (!stateButton || !stateButton.classList.contains('changing'))
            ) {
                input.classList.remove('search-point-form-error');
                unsetCoordinate();
                if (input.value && stateButton) {
                    stateButton.classList.add('changing');
                }
            }
        });
        input.addEventListener('blur', function () {
            setTimeout(function () {
                if (!input.value) {
                    if (stateButton) {
                        stateButton.classList.remove('set', 'changing');
                    }
                } else if (input.value != lastQuery) {
                    ftsform.performSearch();
                }
            }, 100);
        });
        if (stateButton) {
            stateButton.addEventListener('click', function () {
                if (stateButton.classList.contains('changing')) {
                    closePointOnMap(true);
                    if (input.value) {
                        ftsform.performSearch();
                    }
                } else {
                    if (stateButton.classList.contains('set')) {
                        input.value = '';
                        unsetCoordinate();
                    } else {
                        stateButton.classList.add('changing');
                        dispatch('changing');
                        startPointOnMap();
                    }
                }
            });
        }
    };

    let startPointOnMap = function () {
        dispatch('pointonmap');
        pointOnMapBar = document.createElement('div');
        pointOnMapBar.style.cssText =
            'width: 100%; height: 30px; background-color: rgba(255, 255, 255, 0.9); text-align: center; line-height: 30px;';
        pointOnMapBar.innerHTML = 'click_on_map_to_set_coordinate';
        TargeoObj.Base.Map.modules.Controls.addControl(
            'point-location',
            pointOnMapBar,
            {
                align: 'bottom-left',
                edge: true,
                visibilityPriority: 1000,
                attractPriority: 1000,
            }
        );
        pointOnMapListener = TargeoObj.Base.Map.listenOnce(
            'onClick',
            function (evt: any) {
                closePointOnMap(true);
                stateButton.classList.add('set');
                setCoordinate(evt.coords, null, true);
            }
        );
    };

    export const closePointOnMap = function (removeControl: boolean) {
        if (pointOnMapListener) {
            stateButton.classList.remove('changing');
            if (removeControl) {
                TargeoObj.Base.Map.modules.Controls.removeControl(
                    'point-location'
                );
            }
            TargeoObj.Base.Map.unlistenByKey(pointOnMapListener);
            pointOnMapListener = null;
        }
    };

    let setCoordinate = function (
        coords: any,
        item: any,
        updateField: boolean
    ) {
        coords = coords;
        if (stateButton) {
            stateButton.classList.remove('changing');
            stateButton.classList.add('set');
        }
        if (updateField) {
            let gpscoords = TargeoObj.Base.formatGPSCoords(coords);
            input.value = gpscoords.y + ', ' + gpscoords.x;
            input.classList.remove('search-point-form-error');
            input.setAttribute('title', '');
        }
        dispatch('set', { coords: coords, item: item, query: input.value });
    };

    let unsetCoordinate = function () {
        coords = null;
        if (stateButton) {
            stateButton.classList.remove('set');
        }
        dispatch('unset');
    };

    onMount(() => {
        onMapReady().then(() => {
            if (typeof validSearchResult != 'function') {
                validSearchResult = function (item: SuggestItem) {
                    return (
                        item.type == 'coords' ||
                        (item.type == 'place' && item.objecttype == 'BUILDING')
                    );
                };
            }
            ftsform = new TargeoObj.FTSForm('ftsform', {
                placeholder: placeholder,
                button: false,
                history: false,
                resolveExtendedAsSuggest: true,
                suggestElement: suggestElement,
                suggestFormatItem: function (item: any) {
                    if (
                        item.src &&
                        (item.src.xy || item.src.coords) &&
                        (typeof(validSearchResult) == 'function' && validSearchResult(item.src))
                    ) {
                        return item.view;
                    } else {
                        return false;
                    }
                },
            });
            ftsform.initialize(inputContainer);
            input = inputContainer.querySelector('input')!;
            if (label) {
                input.value = lastQuery = label;
            }
            if (coords && stateButton) {
                stateButton.classList.add('set');
            }
            addSearchFormListeners();
        });
    });
</script>

<div class="component-search-form" bind:this={container}>
    <div class="form">
        <div class="form-search" bind:this={inputContainer}></div>
        {#if pointOnMap}
            <div class="form-state" bind:this={stateButton}></div>
        {/if}
    </div>
    <div class="form-suggest-container" style="position: relative;">
        <div
            class="form-suggest"
            style="position: absolute;"
            bind:this={suggestElement}
        ></div>
    </div>
</div>

<style>
    .component-search-form {
        width: 100%;
    }

    :global(.component-search-form .form) {
        display: flex;
        align-items: center;
    }

    :global(.component-search-form .form-search) {
        flex: 1;
    }

    :global(.component-search-form .form input) {
        box-sizing: border-box;
        /*border-radius: 5px;*/
        /*border: 1px solid #ccc;*/
        background-color: #ffffff;
        /*padding: 4px;*/
        padding: var(--input-small-padding);
        border-radius: var(--input-small-border-radius);
        border: var(--input-small-border);
        color: var(--input-small-color);
    }

    :global(.component-search-form .form input.error) {
        border-color: #ff0000;
    }

    :global(.component-search-form .form .targeo-fts-form) {
        align-items: center;
    }

    :global(.component-search-form .form-state) {
        width: 21px;
        height: 21px;
        border-radius: 0 4px 4px 0;
        background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="%23000000" d="M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5A7,7 0 0,0 5,12A7,7 0 0,0 12,19A7,7 0 0,0 19,12A7,7 0 0,0 12,5Z"/></svg>');
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: 16px 16px;
    }

    :global(.component-search-form .form-state.set) {
        background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="%23000000" d="M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5A7,7 0 0,0 5,12A7,7 0 0,0 12,19A7,7 0 0,0 19,12A7,7 0 0,0 12,5Z" /></svg>');
        cursor: pointer;
    }

    :global(.component-search-form .form-state.changing) {
        animation: form-state 1s infinite;
    }

    @keyframes form-state {
        0%,
        100% {
            background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="%23000000" d="M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5A7,7 0 0,0 5,12A7,7 0 0,0 12,19A7,7 0 0,0 19,12A7,7 0 0,0 12,5Z"/></svg>');
        }
        50% {
            background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="%23000000" d="M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5A7,7 0 0,0 5,12A7,7 0 0,0 12,19A7,7 0 0,0 19,12A7,7 0 0,0 12,5Z" /></svg>');
        }
    }

    :global(.component-search-form .form-suggest) {
        position: relative;
        z-index: 1000;
        box-sizing: border-box;
        background-color: #ffffff;
        padding: 3px;
        border: 1px solid #cccccc;
        border-radius: 4px;
        font-size: 12px;
        min-width: 100%;
        max-height: 200px;
        overflow-y: auto;
        display: none;
    }

    :global(.component-search-form .form-suggest:empty) {
        display: none;
    }

    :global(.component-search-form .form-suggest .targeo-suggest-item) {
        padding: 2px 0;
        border-bottom: 1px solid #eee;
        margin: 2px 0;
    }

    :global(
            .component-search-form .form-suggest .targeo-suggest-item:last-child
        ) {
        border-bottom: 0;
    }

    :global(.component-search-form .form-suggest .targeo-suggest-item .exinfo) {
        color: #777;
        font-size: 10px;
    }

    :global(.component-search-form .form-suggest .targeo-countrytable) {
        border: 0;
        box-shadow: none;
    }
</style>
